import React from 'react';

// Partner feedback marquee: one row, one quote per partner, pauses on hover.
// ⚠ DRAFT QUOTES — written as placeholders. Get each partner's approval (or their
// real words) before publishing; never attribute unapproved quotes to a real company.
const QUOTES = [
    { partner: 'Zarposh Collection', logo: '/partners/zarposh.svg', role: 'Fashion brand', text: 'Every order is confirmed on WhatsApp before it ships, and we can see exactly where each outfit is in production. Our team finally spends its time on customers, not on chasing orders.' },
    { partner: 'Emral', logo: 'https://emral.pk/cdn/shop/files/new-logo-emral.jpg?v=1738232674&width=135', role: 'Fashion brand', text: 'Instagram DMs used to pile up after every launch. Now the AI answers price and size questions instantly and hands the special requests to us.' },
    { partner: 'ziml', logo: '/partners/ziml.png', role: 'Retail brand', text: 'One inbox for WhatsApp, Instagram and Messenger changed how we work. Nothing gets missed, and everyone can see who replied to whom.' },
    { partner: 'D.W. Group', logo: '/partners/dwg-ink.png', role: 'Dream. Build. Live.', text: 'The automations follow up with every lead and every customer on time. The visual builder let us set up our own flows without writing code.' },
];

const Card = ({ q }) => (
    <figure className="flex-none w-[320px] md:w-[400px] mx-2.5 bg-card border border-borderLight rounded-card p-6 md:p-7 shadow-hard-soft flex flex-col gap-5">
        <svg width="28" height="22" viewBox="0 0 28 22" fill="#111111" aria-hidden="true"><path d="M0 22V13.2C0 5.9 3.6 1.5 10.4 0l1.3 3.2C8 4.4 6.1 6.9 5.9 10.4h5.5V22H0zm16.3 0V13.2C16.3 5.9 19.9 1.5 26.7 0L28 3.2c-3.7 1.2-5.6 3.7-5.8 7.2h5.5V22H16.3z" /></svg>
        <blockquote className="text-textBody text-[14.5px] md:text-[15.5px] leading-relaxed m-0 flex-1">{q.text}</blockquote>
        <figcaption className="flex items-center justify-between gap-4 pt-4 border-t border-borderLight">
            <div className="flex flex-col">
                <span className="font-bold text-ink tracking-head text-[15px]">{q.partner}</span>
                <span className="font-mono uppercase tracking-label text-[10px] text-textMuted">{q.role}</span>
            </div>
            <img src={q.logo} alt={q.partner} loading="lazy" className="h-6 w-auto max-w-[110px] object-contain grayscale opacity-70" />
        </figcaption>
    </figure>
);

const Row = ({ items, reverse }) => (
    <div className="testi-viewport overflow-hidden py-3">
        <div className={`testi-track flex w-max ${reverse ? 'testi-rev' : ''}`}>
            {[...items, ...items, ...items, ...items].map((q, i) => <Card key={i} q={q} />)}
        </div>
    </div>
);

const Testimonials = () => (
    <section id="feedback" className="w-full py-20 md:py-24 bg-paper border-t border-borderLight scroll-mt-24 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 md:px-10 flex flex-col items-center gap-3 text-center mb-10 md:mb-12">
            <span className="font-mono uppercase tracking-label text-textMuted text-[11px]">What our partners say</span>
            <h2 className="text-3xl md:text-5xl font-bold text-ink tracking-head leading-[1.05]">
                Trusted by growing <span className="font-serif-italic">brands</span>
            </h2>
        </div>
        <Row items={QUOTES} />
    </section>
);

export default Testimonials;
